export const CURRENCY_CONFIG = {
  DEFAULT: 'millions' as const,
  OPTIONS: [
    { label: 'Millions', value: 'millions' as const },
    { label: 'Thousands', value: 'thousands' as const }
  ] as const
} as const;

export type CurrencyValue = typeof CURRENCY_CONFIG.OPTIONS[number]['value'];
